import api from '../api'

export class PlaceManagementInfoApi extends api {
  getById (id) {
    return this.request({
      url: `${this.servicePath}/${this.modulePath}/showBuildingInfo/${id}`,
      method: 'get'
    })
  }
  getAllBuilding () {
    return this.request({
      url: `${this.servicePath}/${this.modulePath}/findAllBuilding`,
      method: 'get'
    })
  }
  delete (id) {
    return this.request({
      url: `${this.servicePath}/${this.modulePath}/deleteBuilding/${id}`,
      method: 'delete'
    })
  }
  batchInsert (items) {
    return this.request({
      url: `${this.servicePath}/${this.modulePath}/addBuildingBatch`,
      method: 'post',
      data: items
    })
  }
  update (form) {
    return this.request({
      url: `${this.servicePath}/${this.modulePath}/editBuilding`,
      method: 'put',
      data: form
    })
  }
}

export default new PlaceManagementInfoApi('placeManagementInfo')
